module.exports = __webpack_public_path__ + "img/H3.94f104de.png";